enum Language {
	EN = 'en-US',
	PT = 'pt-PT',
	NL = 'nl-NL',
}

export default Language;
